module.exports = __webpack_public_path__ + "img/g0002.2f0e1987.png";